import React, { useCallback } from 'react';
import {ReadOnlySupport} from "./utils/ReadOnlySupport";
import {Radio as AntRadio} from 'antd';

export const RadioGroup = React.forwardRef((props, ref) => {
    const { children } = props;

    const whenReadOnly = useCallback(() => {
        const readOnlyProps = {
            ...props,
            onChange: () => {},
            onClick: () => {},
            className: 'ant-custom-readonly',
        };

        return (
            <AntRadio.Group {...readOnlyProps}>
                {children}
            </AntRadio.Group>
        );
    }, [children, props]);

    const notReadOnly = useCallback(() => (
        <AntRadio.Group {...props} ref={ref}>
            {children}
        </AntRadio.Group>
    ), [children, props, ref]);

    return <ReadOnlySupport
        {...props}
        whenReadOnly={whenReadOnly}
        notReadOnly={notReadOnly}
    />;
});

RadioGroup.Button = AntRadio.Button;
